module.exports = __webpack_public_path__ + "img/step-2.13108e6f.jpg";